import { FilterKindEnum } from '../../../../domains/global-filters/model/FilterChain';
import { getLabels } from '../../../../utils/LabelFormatter/SingleLabelFormatter/SurveyCompletionLabelFormatter';
import { getFilterMetadata } from '../../FilterChainUtils';
import { GenericRadioFilter } from '../GenericBloc/GenericRadioFilter/GenericRadioFilter';
import type { AbstractSingleFilterPillsProps } from '../SingleFilterType';
import { OPTION_LIST } from './SurveyCompletionFilterConstant';
import type { SURVEY_COMPLETION_TYPE } from './SurveyCompletionFilterType';

export function SurveyCompletionFilter({
  currentValue,
  autoFocus,
  onApply,
  onRemove,
  onDropdownHidden,
  showDropdownOnMount,
}: AbstractSingleFilterPillsProps<SURVEY_COMPLETION_TYPE>): JSX.Element {
  const metadata = getFilterMetadata(FilterKindEnum.SurveyCompletionKind);
  const { label1, label2 } = getLabels(currentValue);
  return (
    <GenericRadioFilter
      autoFocus={autoFocus}
      filterName={metadata.filterName}
      iconName={metadata.iconName}
      currentValue={currentValue}
      onApply={onApply}
      onRemove={onRemove}
      optionList={OPTION_LIST}
      label1={label1}
      label2={label2}
      onDropdownHidden={onDropdownHidden}
      showDropdownOnMount={showDropdownOnMount}
    />
  );
}
